export const FETCH_VERSION = 'FETCH_VERSION'
export const FETCH_VERSION_SUCCESS = 'FETCH_VERSION_SUCCESS'
export const FETCH_VERSION_ERROR = 'FETCH_VERSION_ERROR'
export const FETCH_SEARCH_TOKEN = 'FETCH_SEARCH_TOKEN'
export const FETCH_SEARCH_TOKEN_SUCCESS = 'FETCH_SEARCH_TOKEN_SUCCESS'
